export const CHECKING_TITLE_TEMPLATE = '%s - Checking | Betterment';
export const CHECKING_DEFAULT_TITLE = 'Checking | Betterment';
